export default "__VITE_ASSET__855e2719__"